<template>
  <div>
    <items-list
      :businessId="businessId"
      :query="query"
      :filters="filters"
      :targetEntityId="targetEntityId"
      category="past-due"
      @deny="deny"
      @approve="approve"
      @assign="assign"
      @comment="comment"
      @del="del"
      @history="history"
    />
  </div>
</template>

<script>
import ItemsList from "@/views/business/todo/components/ItemsList";

export default {
  name: "AssignedTodoView",
  props: {
    businessId: String,
    query: String,
    targetEntityId: String,
    filters: Object,
  },
  components: { ItemsList },
  methods: {
    assign(item) {
      this.$emit("assign", item);
    },
    approve(item) {
      this.$emit("approve", item);
    },
    deny(item) {
      this.$emit("deny", item);
    },
    del(item) {
      this.$emit("del", item);
    },
    comment(item) {
      this.$emit("comment", item);
    },
    history(item) {
      this.$emit("history", item);
    },
  },
};
</script>
